import React from 'react';
import { useAuth, useUser } from '@clerk/clerk-react';
import { Navigate, useLocation } from 'react-router-dom';
import { useRole } from '../../lib/useRole';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isLoaded, isSignedIn } = useAuth();
  const { user } = useUser();
  const { role } = useRole();
  const location = useLocation();

  if (!isLoaded) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-accent-wood border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-primary-700">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isSignedIn) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(role)) {
    return (
      <div className="max-w-2xl mx-auto p-6 flex justify-center">
        <div className="bg-white rounded-xl shadow-lg p-6 border border-primary-200">
          <h2 className="text-4xl tracking-[0.1em] sm:tracking-[0.2em] text-center">
            <span className="font-light text-primary-900">Access</span>
            <span className="font-light text-accent-wood ml-1 sm:ml-2">Denied</span>
          </h2>
          <p className="text-primary-600 text-center mt-4">
            You don't have permission to access this page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
} 